var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("sc-city-title " + _vm.$mq)]},[_c('r-icon',{attrs:{"name":_vm.iconName,"size":24}}),_c('r-title',{attrs:{"type":"title-1","colorType":"secondary"}},[_vm._v(_vm._s(_vm.$t(_vm.city)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }